var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 17,
    fill: "#404040"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Educator flow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3392 -1282C-3392 -1283.1 -3391.1 -1284 -3390 -1284H20349C20350.1 -1284 20351 -1283.1 20351 -1282V22601C20351 22602.1 20350.1 22603 20349 22603H-3390C-3391.1 22603 -3392 22602.1 -3392 22601V-1282Z",
    fill: "#807E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3390 -1283H20349V-1285H-3390V-1283ZM20350 -1282V22601H20352V-1282H20350ZM20349 22602H-3390V22604H20349V22602ZM-3391 22601V-1282H-3393V22601H-3391ZM-3390 22602C-3390.55 22602 -3391 22601.6 -3391 22601H-3393C-3393 22602.7 -3391.66 22604 -3390 22604V22602ZM20350 22601C20350 22601.6 20349.6 22602 20349 22602V22604C20350.7 22604 20352 22602.7 20352 22601H20350ZM20349 -1283C20349.6 -1283 20350 -1282.55 20350 -1282H20352C20352 -1283.66 20350.7 -1285 20349 -1285V-1283ZM-3390 -1285C-3391.66 -1285 -3393 -1283.66 -3393 -1282H-3391C-3391 -1282.55 -3390.55 -1283 -3390 -1283V-1285Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Doctor sign in"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1536,
    height: 864,
    transform: "translate(-1275 -412)",
    fill: "#C3E7E8",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 625484"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17266",
    x: -487,
    y: -226,
    width: 544,
    height: 317,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 625491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 18289"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16875",
    x: -461,
    y: -18,
    width: 493,
    height: 53,
    rx: 10,
    fill: "#29BCC1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 16903",
    d: "M-21.4189 -18H21.5811C27.1039 -18 31.5811 -13.5228 31.5811 -8V25C31.5811 30.5229 27.1039 35 21.5811 35H-21.4189V-18Z",
    fill: "#078A8E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M0.767578 15.2793L8.00729 8.49206C8.09158 8.41305 8.09158 8.27926 8.00729 8.20025L0.767578 1.41302",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBtn);
export default __webpack_public_path__ + "static/media/arrowBtn.9268118be7d5740c1027f2417cbd023f.svg";
export { ForwardRef as ReactComponent };